/**
 * @param {object|null} query
 * @param {object|null} cookies
 * @param {string|null} path
 * @param {string} country
 * @param {object} config
 * @param {object} config.translations
 * @returns {*}
 */
function setLocale ({ query = null, cookies = null, path = null, country, config }) {
  if (!country || !config) return

  const defaultLocale = config?.translations?.[country]?.default
  if (!defaultLocale) return

  const options = config?.translations?.[country]?.options
  if (!options) return

  let locale = query?.locale || cookies?.locale || defaultLocale

  if (path && options) {
    for (const l of options) {
      if (path?.startsWith(`/${l}`)) {
        locale = l
        break
      }
    }
  }

  if (path === '/') {
    locale = defaultLocale
  }

  return options?.includes(locale)
    ? locale
    : defaultLocale
}

module.exports = { setLocale }
